"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLICK_LAYER_CATEGORY_KEY = 'base';
exports.CLICK_LAYER_COMPONENT_KEY = 'clickLayer';